/**
 * Pixel dimensions of every guide screenshot.
 *
 * WHY THIS EXISTS: the guide lazy-loads 27 screenshots. An `<img>` with
 * no intrinsic size reserves no height until it decodes, so the page
 * grows by thousands of pixels as you scroll — which shifts content
 * under the reader and lands anchor links in the wrong place.
 *
 * Feeding these into `aspect-ratio` reserves the right box up front, so
 * the layout never moves.
 *
 * Regenerated by `npm run guide:capture`. Do not hand-edit.
 */
const SHOT_DIMENSIONS: Record<string, [number, number]> = {
  'account-detail': [1489, 812],
  'activity-feed': [897, 642],
  'activity-heatmap': [1489, 812],
  'depletions-overview': [1489, 812],
  'edit-rep': [600, 505],
  'flag-account': [1489, 812],
  'follow-up-tracker': [1489, 812],
  'growth-decline': [1489, 812],
  home: [1568, 660],
  'log-visit': [1489, 812],
  'manually-added': [1489, 812],
  'monthly-trend': [1489, 812],
  'no-shipments': [1568, 690],
  'my-logs': [1489, 812],
  'my-territories': [1489, 812],
  'new-vs-lost': [1489, 812],
  orders: [1489, 812],
  'oversight-overview': [1489, 812],
  'premises-mix': [1489, 812],
  'product-performance': [1489, 812],
  'regional-sales-overview': [1489, 812],
  'rep-roster': [629, 642],
  'state-breakdown': [1489, 812],
  'team-chat': [1489, 812],
  'todays-plan': [1489, 812],
  'top-accounts': [1489, 812],
  'view-as-rep': [1489, 812],
  'what-if': [1489, 812],
};

/** Aspect ratio for a shot, defaulting to the common capture frame. */
export function shotAspectRatio(id: string): number {
  const dim = SHOT_DIMENSIONS[id];
  if (!dim) return 1489 / 812;
  return dim[0] / dim[1];
}
